import Asset from '@sitebase/ui-kit/es/Asset';

import EmptyIcon from '@wh/svg-icons/None';
import PropTypes from 'prop-types';
import React from 'react';

var IconAsset = function IconAsset(_ref) {
  var name = _ref.name;

  var className = 'sb-icon-' + name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  return React.createElement(
    'span',
    { className: className },
    React.createElement(Asset, { name: name, loaderNode: React.createElement(EmptyIcon, null), errorNode: React.createElement(EmptyIcon, null) })
  );
};

IconAsset.propTypes = {
  name: PropTypes.string.isRequired
};

export default IconAsset;
//# sourceMappingURL=IconAsset.js.map